<template>
  <div id="totalBox">
    <div class="CModelIntro">
      <img src="../../assets/product/CModelIMG1.png" class="CModelIMG1" alt="" />
      <img src="../../assets/product/CModelIMG2.png" class="CModelIMG2" alt="" />
      <div class="cIntroContent">
        <div class="contentTitle">
                  用户端（C端）
        </div>
        <div class="contentText firstText">
                  任马停客户端（C端）是一款针对停车难、停车乱、停车贵等一系列当今社会急需解决的问题所研发的APP。
        </div>
        <div class="contentText">
                  它是一款集成多技术于一体的服务平台APP，以移动互联网、物联网、云计算、大数据、人工智能以及超声雷达等技术为基础，旨在解决停车位资源不对等的社会现状，为用户停车提供更好的服务和体验。
        </div>
      </div>
    </div>
    <div class="Cfeatures">
      <p class="featuresTitle">产品特色</p>
      <div class="featuresListBox">
        <div class="featuresList">
          <img src="../../assets/product/appointIcon.png" class="listIcon"/>
          <div class="listTitle">预约车位</div>
          <ul class="listContent">
            <li class="listContentList">
                          车位提前预约
            </li>
            <li class="listContentList">
                          省时更省力
            </li>
          </ul>
        </div>
        <div class="featuresList">
          <img src="../../assets/product/comboIcon.png" class="listIcon"/>
          <div class="listTitle">套餐充值</div>
          <ul class="listContent">
            <li class="listContentList">
                         多款套餐，多个优惠
            </li>
            <li class="listContentList">
              总有一个适合你
            </li>
          </ul>
        </div>
        <div class="featuresList">
          <img src="../../assets/product/rentPark.png" class="listIcon"/>
          <div class="listTitle">车位租赁</div>
          <ul class="listContent">
            <li class="listContentList">
                          车位买？车位卖？
            </li>
            <li class="listContentList">
              一站式服务超方便
            </li>
          </ul>
        </div>
        <div class="featuresList">
          <img src="../../assets/product/illegalIcon.png" class="listIcon"/>
          <div class="listTitle">违章查询</div>
          <ul class="listContent">
            <li class="listContentList">
                          车辆违章随时查
            </li>
          </ul>
        </div>
        <div class="featuresList">
          <img src="../../assets/product/myPark.png" class="listIcon"/>
          <div class="listTitle">我的车位</div>
          <ul class="listContent">
            <li class="listContentList">
                         空闲车位能生钱
            </li>
          </ul>
        </div>
        <div class="featuresList">
          <img src="../../assets/product/themeSet.png" class="listIcon"/>
          <div class="listTitle">主题设置</div>
          <ul class="listContent">
            <li class="listContentList">
                            我们不要一成不变
            </li>
            <li class="listContentList">
              主题变换随心意
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="downloadBox">
      <div class="downloadContent">
        <div class="downloadTitle">下载APP体验更多功能</div>
        <img src="../../assets/product/appErcode.png" class="appErcode" alt="" />
        <p class="scanTip">扫码下载</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CModel',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}
.CModelIntro{
  width:1200px;
  height:580px;
  margin: 0 auto;
  background:rgba(249,249,249,1);
  margin-top: 36px;
  padding: 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.CModelIMG1{
  width: 314px;
  height: 537px;
}
.CModelIMG2{
  width: 264px;
  height: 444px;
}
.cIntroContent{
  width: 378px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 95px;
}
.contentTitle{
  font-size:28px;
  font-weight:400;
  color:rgba(0,0,0,1);
}
.contentText{
  width: 378px;
  font-size:18px;
  font-weight:400;
  color:rgba(117,117,117,1);
  text-align: left;
  line-height: 30px;
}
.firstText{
  margin-top: 20px;
}
.Cfeatures{
  width: 1200px;
  height: 360px;
  padding-top: 57px;
  margin: 0 auto;
}
.featuresTitle{
  font-size:28px;
  font-weight:400;
  color:rgba(0,0,0,1);
}
.featuresListBox{
  width: 1200px;
  margin-top: 53px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}
.featuresList{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.listIcon{
  width: 54px;
  height: 54px;
  margin-bottom: 20px;
}
.listTitle{
  font-size:20px;
  font-weight:400;
  color:rgba(0,0,0,1);
}
.listContent{
  margin-top: 15px;
}
.listContentList{
  font-size:15px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:20px;
}
.downloadBox{
  width: 100%;
  background-color: RGBA(35, 33, 33, 1);
  height: 500px;
}
.downloadContent{
  background-color: rgba(35,33,33,0.7);
  width: 1200px;
  height: 500px;
  background-repeat: no-repeat;
  margin: 0 auto;
  background-image: url(../../assets/product/download.png);
  padding-top: 100px;
}
.downloadTitle{
  font-size:60px;
  font-weight:bold;
  color:rgba(255,255,255,1);
}
.appErcode{
  width: 158px;
  height: 158px;
  margin-top: 39px;
}
.scanTip{
  font-size:20px;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/CModel.vue